





import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "ui-toolbar-separator"
})
export default class UiToolbarSeparatorComponent extends Vue {
 
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-toolbar/src/ui-toolbar-separator.vue